module.exports = __webpack_public_path__ + "img/wjmmleftbg.fae9c6f6.png";